document.addEventListener("DOMContentLoaded", () => {

    const sticky = document.getElementById("rxnStickyATC");
    const trigger = document.querySelector(".rxn-buy-wrapper");

    if (!sticky || !trigger) return;

    function toggleSticky() {

    const rect = trigger.getBoundingClientRect();

    // Jab Buy Now button viewport me dikhe to Sticky hide
    if (rect.top < window.innerHeight && rect.bottom > 0) {

        sticky.classList.remove("show");

    } else {

        sticky.classList.add("show");

    }

    }
    window.addEventListener("scroll", toggleSticky, { passive: true });

    window.addEventListener("resize", toggleSticky);

    toggleSticky();
    

    /*==============================
Sticky → Original Variant Sync
==============================*/

const stickyOptions = document.querySelectorAll(".rxn-sticky-option");

stickyOptions.forEach((select, optionIndex) => {

    select.addEventListener("change", function () {

        const value = this.value;

        const radios = document.querySelectorAll(
            `input[name="${this.dataset.optionName}"]`
        );

        radios.forEach(radio => {

            if (radio.value === value) {

                radio.checked = true;

                radio.dispatchEvent(new Event("change", {
                    bubbles: true
                }));

                radio.dispatchEvent(new Event("click", {
                    bubbles: true
                }));

            }

        });

    });

});


/*==============================
Quantity Sync
==============================*/

const stickyQty = document.getElementById("rxnStickyQty");

const originalQty = document.querySelector(
    '.product-form quantity-input .quantity__input'
);

const originalPlus = document.querySelector(
    '.product-form quantity-input button[name="plus"]'
);

const originalMinus = document.querySelector(
    '.product-form quantity-input button[name="minus"]'
);

const stickyPlus = document.querySelector(
    '.rxn-qty-btn[data-action="plus"]'
);

const stickyMinus = document.querySelector(
    '.rxn-qty-btn[data-action="minus"]'
);

if (
    stickyQty &&
    originalQty &&
    originalPlus &&
    originalMinus
) {

    // Initial Value
    stickyQty.value = originalQty.value;

    // Original → Sticky
    originalQty.addEventListener("input", () => {
        stickyQty.value = originalQty.value;
    });

    originalQty.addEventListener("change", () => {
        stickyQty.value = originalQty.value;
    });

    // Sticky +
    stickyPlus.addEventListener("click", () => {

        originalPlus.click();

        setTimeout(() => {

            stickyQty.value = originalQty.value;

        }, 30);

    });

    // Sticky -
    stickyMinus.addEventListener("click", () => {

        originalMinus.click();

        setTimeout(() => {

            stickyQty.value = originalQty.value;

        }, 30);

    });

}


syncSticky();

/*==================================
RXN Variant Changed
==================================*/

document.addEventListener("rxn:variantChanged", function (e) {

    const variant = e.detail.variant;

    if (!variant) return;

    // Sticky Variant Dropdowns
    const stickyOptions = document.querySelectorAll(".rxn-sticky-option");

    stickyOptions.forEach((select, index) => {

        if (variant.options[index]) {
            select.value = variant.options[index];
        }

    });

    // Sticky Quantity
    const originalQty = document.querySelector(
        ".product-form quantity-input .quantity__input"
    );

    const stickyQty = document.getElementById("rxnStickyQty");

    if (originalQty && stickyQty) {
        stickyQty.value = originalQty.value;
    }

});

});
